import { PasswordVerificationState } from 'types/passwordVerification'

import {
  PASSWORD_VERIFICATION_CHECK,
  PASSWORD_VERIFICATION_CHECK_FAILURE,
  PASSWORD_VERIFICATION_CHECK_SUCCESS,
  PASSWORD_VERIFICATION_CHECK_LOGIN,
  PASSWORD_VERIFICATION_CHECK_LOGIN_SUCCESS,
  PASSWORD_VERIFICATION_CHECK_LOGIN_FAILURE,
} from './constants'
import { PasswordVerificationActionTypes } from './actions'

export const initialState: PasswordVerificationState = {
  tournamentId: null,
  tournamentName: '',
  startTime: null,
  courseName: '',
  passwordVerification: null,
  isLoading: false,
  error: null,
  isUserVerified: false,
  heroImage: {
    extraInfo: '',
    fileType: '',
    id: 0,
    url: '',
  },
  units: 'metric',
}

const passwordVerificationReducer = (
  state = initialState,
  action: PasswordVerificationActionTypes,
): PasswordVerificationState => {
  switch (action.type) {
    case PASSWORD_VERIFICATION_CHECK:
      return {
        ...state,
        tournamentId: action.tournamentId,
        isLoading: true,
        error: undefined,
      }
    case PASSWORD_VERIFICATION_CHECK_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        error: undefined,
      }
    case PASSWORD_VERIFICATION_CHECK_FAILURE:
      return {
        ...initialState,
        error: action.error,
      }
    case PASSWORD_VERIFICATION_CHECK_LOGIN:
      return {
        ...state,
        tournamentId: action.tournamentId,
        isUserVerified: false,
        isLoading: true,
        error: undefined,
      }
    case PASSWORD_VERIFICATION_CHECK_LOGIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isUserVerified: true,
        error: undefined,
      }
    case PASSWORD_VERIFICATION_CHECK_LOGIN_FAILURE:
      return {
        ...state,
        isLoading: false,
        isUserVerified: false,
        error: action.error ? action.error : { error: 'Password verification failed' },
      }
    default:
      return state
  }
}

export { passwordVerificationReducer }
